export const REMOVE = "Remove";

export const SuperAdminType = [
	{ id: 1, role: "Admin" },
	{ id: 2, role: "Reseller" },
];

export const RESELLER_ID = 2;
